import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconVolumeLow$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVolumeLow extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a88cf9deb4103d32ae2973fc42b79e012fa03b29', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '77031fc07800336ab06715d1ff265d256b11011b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3e20a61e0509d38aa4583252cd860f92de105e91', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.17 5.71 7.62 8H4.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h3.11l2.56 2.26a.5.5 0 0 0 .83-.37V6.08a.5.5 0 0 0-.83-.37", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-volume-low", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-volume-low"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-volume-low":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVolumeLow$1);
            }
            break;
    } });
}

const CosmosIconVolumeLow = CosmosIconVolumeLow$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVolumeLow, defineCustomElement };
